import React, { useCallback, useMemo } from "react";
import { View } from "react-native";
import { useI18n } from "@lookiero/i18n-react";
import { useMediaImage } from "@lookiero/sty-psp-ui";
import { OptionImage } from "../../../../atom/optionImage/OptionImage";
import { useAnswerForId } from "../../behaviours/useAnswers";
import { useAnswersValidation } from "../../behaviours/useAnswersValidation";
import { style as avoidImageQuestionItemStyle } from "./AvoidImageQuestionItem.style";
const AvoidImageQuestionItem = ({ domain, segment, question, questionParentId, }) => {
    const cdnImageUrl = useMediaImage();
    const style = useMemo(() => avoidImageQuestionItemStyle(), []);
    const resizeMode = question.metadata.resizeMode || "cover";
    const aspectRatio = question.metadata.aspectRatio || 5 / 4;
    const backgroundColor = question.metadata.backgroundColor;
    const { formatMessage } = useI18n({ domain });
    const titleText = question.translationKey
        ? formatMessage({ id: question.translationKey }, { segment: segment.toLowerCase() })
        : undefined;
    const { answer, onChange } = useAnswerForId({ id: questionParentId });
    const selected = Boolean(answer && answer.find((id) => id === question.id));
    const { validateMaxAnswers } = useAnswersValidation();
    const handleOnPress = useCallback(() => {
        onChange({ questionId: question.id, answer: selected ? undefined : question.id });
        validateMaxAnswers();
    }, [onChange, question.id, selected, validateMaxAnswers]);
    return (React.createElement(View, { style: style.container, testID: "avoid-image-question-item" },
        React.createElement(OptionImage, { aspectRatio: aspectRatio, checked: selected, icon: "close", imageResizeMode: resizeMode, src: cdnImageUrl({ url: question.metadata.source, width: 400 }), testID: question.id, text: titleText, title: question.translationKey, value: question.translationKey, style: {
                image: {
                    backgroundColor,
                },
                icon: {
                    icon: style.icon,
                    iconContainer: style.iconContainer,
                },
            }, onChange: handleOnPress })));
};
export { AvoidImageQuestionItem };
